<template>
  <vx-card class="shadow-xl rounded-lg">
    <div class="weekly-calendar">
      <!-- Calendar Header -->
      <div class="calendar-header">
        <vs-button color="neutral" @click="navigateWeek(-1)"> <feather-icon icon="ChevronLeftIcon" svgClasses="h-4 w-4"
            class="mr-1" />Previous Week</vs-button>
        <span style="font-weight: bold;">WEEK {{ weekRange }}</span>
        <vs-button color="neutral" @click="navigateWeek(1)">Next Week<feather-icon icon="ChevronRightIcon"
            svgClasses="h-4 w-4" class="ml-1" /> </vs-button>
      </div>
      <!-- Days of the Week and Categories -->
      <div class="week-days" style="min-height: 500px">
        <div class="day-container" v-for="(day, index) in weekDays" :key="index"
          :class="{ 'no-border': index === weekDays.length - 1 }">
          <!-- Day Header -->
          <div class="day" :class="{ 'today': isToday(day.fullDate) }">
            <div class="day-name" v-if="isToday(day.fullDate) "><b>TODAY</b>, {{ day.name }}</div>
            <div class="day-name" v-else>{{ day.name }}</div>
            <div class="day-number">{{ day.date }}</div>
          </div>
          <hr class="elegant-hr mt-0 mb-2" />
          <!-- Categories -->
          <div class="categories" v-if="eventsForDay(day.fullDate, 'Transport').length > 0">
            <div class="category-content mt-8">
              <div slot="header" style="text-align:left;font-size:80%"><span class="ml-6"><b>Transport</b></span></div>
              <div v-for="event in eventsForDay(day.fullDate, 'Transport')" :key="event.id">
                <span class="troisd" @click="openEditEvent(event)" style="cursor: pointer;">
                  <div :style="getStyleCalendar(event.classes)">{{ gettitle(event.title)
                    }}</div>
                </span>
              </div>
            </div>
          </div>
          <div class="categories" v-if="eventsForDay(day.fullDate, 'Reception').length > 0">
            <div class="category-content mt-8">
              <div slot="header" style="text-align:left;font-size:80%"><span class="ml-6"><b>Reception</b></span></div>
              <div v-for="event in eventsForDay(day.fullDate, 'Reception')" :key="event.id">
                <span class="troisd" @click="openEditEvent(event)" style="cursor: pointer; ">
                  <div :style="getStyleCalendar(event.classes)">{{ gettitle(event.title)
                    }}</div>
                </span>
              </div>
            </div>
            </div>
          <div class="categories" v-if="eventsForDay(day.fullDate, 'Purchase Order').length > 0">
            <div class="category-content mt-8">
              <div slot="header" style="text-align:left;font-size:80%"><span class="ml-6"><b>Purchase Order</b></span></div>
              <div v-for="event in eventsForDay(day.fullDate, 'Purchase Order')" :key="event.id">
                <span class="troisd" @click="openEditEvent(event)" style="cursor: pointer; ">
                  <div :style="getStyleCalendar('event-po')">{{ gettitle(event.title)
                    }}</div>
                </span>
              </div>
            </div>
          </div>
          <div class="categories" v-if="eventsForDay(day.fullDate, 'Production').length > 0">
            <div class="category-content mt-8">
              <div slot="header" style="text-align:left;font-size:80%"><span class="ml-6"><b>Production</b></span></div>
              <div v-for="event in eventsForDay(day.fullDate, 'Production')" :key="event.id">
                <span class="troisd" style="cursor: pointer; ">
                  <div :style="getStyleCalendar('event-production')">+ {{ gettitle(event.title)
                    }}</div>
                </span>
              </div>
            </div>
          </div>
          <div class="categories" v-if="eventsForDay(day.fullDate, 'Harvesting').length > 0">
            <div class="category-content mt-8">
              <div slot="header" style="text-align:left;font-size:80%"><span class="ml-6"><b>Harvesting</b></span></div>
              <div v-for="event in eventsForDay(day.fullDate, 'Harvesting')" :key="event.id">
                <span class="troisd" style="cursor: pointer; ">
                  <div :style="getStyleCalendar('event-production')">{{ gettitle(event.title)
                    }}</div>
                </span>
              </div>
            </div>
          </div>
          <div class="categories" v-if="eventsForDay(day.fullDate, 'Birthday').length > 0">
            <div class="category-content mt-8">
              <div slot="header" style="text-align:left;font-size:80%"><span class="ml-6"><b>Birthday</b></span></div>
              <div v-for="event in eventsForDay(day.fullDate, 'Birthday')" :key="event.id">
                <span class="troisd" style="cursor: pointer; ">
                  <div :style="getStyleCalendar('event-birthday')">{{ gettitle(event.title)
                    }}</div>
                </span>
              </div>
            </div>
          </div>
          <div class="categories" v-if="eventsForDay(day.fullDate, 'Working Birthday').length > 0">
            <div class="category-content mt-8">
              <div slot="header" style="text-align:left;font-size:80%"><span class="ml-6"><b>Work Anniversary</b></span></div>
              <div v-for="event in eventsForDay(day.fullDate, 'Working Birthday')" :key="event.id">
                <span class="troisd" style="cursor: pointer; ">
                  <div :style="getStyleCalendar('event-working-birthday')">{{ gettitle(event.title).replace('0 years','day 0').replace('1 years','1 year')
                    }}</div>
                </span>
              </div>
            </div>
          </div>
          <!--<div class="categories" v-if="eventsForDay(day.fullDate, 'Attendance').length > 0">
            <div class="category-content">
              <div slot="header" style="text-align:left;font-size:80%"><span class="ml-6"><b>Attendance</b></span></div>
              <div v-for="event in eventsForDay(day.fullDate, 'Attendance')" :key="event.id">
                <span @click="openEditEvent(event)" style="cursor: pointer; ">
                  <div :style="getStyleCalendar('event-production')" v-if="!event.title.includes('days')">{{ gettitle(event.title) }}</div>
                  <div :style="getStyleCalendar('event-red')" v-else>Employee not logged out</div>
                </span>
              </div>
            </div>
          </div>-->
        </div>
      </div>
    </div>
    <!-- VIEW EVENT -->
    <vs-prompt class="calendar-event-dialog" title="Operation" accept-text="View" button-cancel="border"
      @cancel="removeEvent" @accept="clickViewEvent(labelLocal.toLowerCase())" :active.sync="activePromptEditEvent">

      <div class="my-4">
        <big class="date-label"><b>Title</b></big>
        {{ title }}
      </div>
      <div class="my-4">
        <big class="date-label"><b>Date</b></big>
        {{ startDate }}
      </div>
      <div v-if="labelLocal === 'Reception'" class="my-4">
        <big class="date-label"><b>Supplier</b></big>
        {{ client }}
      </div>
      <div v-if="labelLocal === 'Transport' && client" class="my-4">
        <big class="date-label"><b>Transporter</b></big>
        {{ client }}
      </div>
      <div v-if="labelLocal === 'Transport' && client2" class="my-4">
        <big class="date-label"><b>Client</b></big>
        {{ client2 }}
      </div>
      <div class="my-4" v-if="labelLocal !== 'Transport'">
        <big class="date-label"><b>Product Category</b></big>
        {{ category_name }}
      </div>
      <div class="my-4" v-if="labelLocal !== 'Transport'">
        <big class="date-label"><b>Product</b></big>
        {{ product_name }}
      </div>
      <div class="my-4" v-if="labelLocal !== 'Transport'">
        <big class="date-label"><b>Volume</b></big>
        {{ volume }} m3
      </div>
      <div class="my-4" v-if="volume2 && labelLocal === 'Transport'">
        <big class="date-label"><b>Quotation</b></big>
        {{ ref_quote }}
      </div>
      <div class="my-4" v-if="volume2 && labelLocal === 'Transport'">
        <big class="date-label"><b>Volume Transported</b></big>
        {{ volume2 }} m3
      </div>
      <div class="my-4" v-if="price && labelLocal === 'Transport' && this.isadmin">
        <big class="date-label"><b>Transport cost</b></big>
        {{ price / volume }} €
      </div>
      <div class="my-4" v-if="price2 && labelLocal === 'Transport' && this.isadmin">
        <big class="date-label"><b>Transport value</b></big>
        {{ price2 }} €
      </div>
      <div class="my-4" v-if="price && labelLocal === 'Reception' && this.isadmin">
        <big class="date-label"><b>Cost</b></big>
        {{ price }} €
      </div>
      <div class="my-4" v-if="price && labelLocal === 'Purchase Order' && this.isadmin">
        <big class="date-label"><b>Cost</b></big>
        {{ price }} €
      </div>
    </vs-prompt>
    <div>
      <span class="mt-4"
        style="display: inline-block; width: 20px; height: 10px; background-color: #55DD92; margin-right: 5px;"></span>
      <span style="font-size:12px">Transport to Clients</span>
    </div>
    <div>
      <span class="mt-2"
        style="display: inline-block; width: 20px; height: 10px; background-color: #F97794; margin-right: 5px;"></span>
      <span style="font-size:12px">Reception</span>
    </div>
    <div>
      <span class="mt-2"
        style="display: inline-block; width: 20px; height: 10px; background-color: #ffc085; margin-right: 5px;"></span>
      <span style="font-size:12px">Purchase Order</span>
    </div>
    <div>
      <span class="mt-2"
        style="display: inline-block; width: 20px; height: 10px; background-color: #7DA7BC; margin-right: 5px;"></span>
      <span style="font-size:12px">Harvesting & Production</span>
    </div>
    <div>
      <span class="mt-2"
        style="display: inline-block; width: 20px; height: 10px; background-color: #f5f2bf; margin-right: 5px;"></span>
      <span style="font-size:12px">Birthday</span>
    </div>
    <div>
      <span class="mt-2"
        style="display: inline-block; width: 20px; height: 10px; background-color: #f0f0f0; margin-right: 5px;"></span>
      <span style="font-size:12px">Work Anniversary</span>
    </div>
  </vx-card>
</template>


<script>
import moment from 'moment';
import moduleCalendar from '@/store/calendar/moduleCalendar.js'

export default {
  name: 'WeeklyCalendar',
  data() {
    return {
      activePromptEditEvent: false,
      currentDate: moment(),
      weekDays: [],
      isadmin: false,
      showDate: new Date(),
      disabledFrom: false,
      id: 0,
      title: '',
      client: '',
      product_name: '',
      client2: '',
      category_name: '',
      ref_quote: '',
      volume: '',
      volume2: '',
      startDate: '',
      labelLocal: 'none',
      price: '',
      price2: '',

    };
  },
  computed: {
    weekRange() {
      if (this.weekDays.length === 0) return '';
      let start = this.weekDays[0].date;
      let end = this.weekDays[this.weekDays.length - 1].date;
      let month = this.weekDays[0].fullDate ? moment(this.weekDays[0].fullDate).format('MMMM') : '';
      let year = this.weekDays[0].fullDate ? moment(this.weekDays[0].fullDate).format('YYYY') : '';
      return `${start} - ${end} ${month} ${year}`;
    },
    simpleCalendarEvents() {
      // Assumons que les événements sont déjà chargés dans le store et disponibles
      const events = this.$store.state.calendar.events;
      return events.filter(event => {
        return this.weekDays.some(day => day.fullDate === moment(event.startDate).format('YYYY-MM-DD'));
      });
    },
  },
  methods:
  {
    /*
        'primary': '#A9A2F6',
        'success': '#55DD92',
        'warning': '#ffc085',
        'danger': '#F97794'
    */
    replaceWithLineBreak(title) {
      return title.replace("@","<br/>");
    },
    getStyleCalendar(color) {
      if (color === 'event-success') {
        return 'background-color:#55DD92; color:#fff; border-radius: 8px; box-shadow: 3px 3px 3px rgba(0, 0, 0, 0.5);padding:5px; margin:8px;font-size:12px;text-align:left'
      }
      else if (color === 'event-po') {
        return 'background-color:#ffc085; color:#fff; border-radius: 8px; box-shadow: 3px 3px 3px rgba(0, 0, 0, 0.5);padding:5px; margin:8px;font-size:12px;text-align:left'
      }
      else if (color === 'event-production') {
        return 'background-color:#7DA7BC; color:#fff; border-radius: 8px; box-shadow: 3px 3px 3px rgba(0, 0, 0, 0.5);padding:5px; margin:8px;font-size:12px;text-align:left'
      }
      else if (color === 'event-red') {
        return 'background-color:red; color:#fff; border-radius: 8px; box-shadow: 3px 3px 3px rgba(0, 0, 0, 0.5);padding:5px; margin:8px;font-size:12px;text-align:left'
      }
      else if (color === 'event-birthday') {
        return 'background-color:#f5f2bf; color:#A0A0A0; border-radius: 8px; box-shadow: 3px 3px 3px rgba(0, 0, 0, 0.5);padding:5px; margin:8px;font-size:12px;text-align:left'
      }
      else if (color === 'event-working-birthday') {
        return 'height:auto;background-color:#f0f0f0; color:#A0A0A0; border-radius: 8px; box-shadow: 3px 3px 3px rgba(0, 0, 0, 0.5);padding:5px; margin:8px;font-size:12px;text-align:left'
      }
      else
        return 'background-color:#F97794; color:#fff; border-radius: 8px; box-shadow: 3px 3px 3px rgba(0, 0, 0, 0.5);padding:5px; margin:8px;font-size:12px;text-align:left'
    },
    gettitle(title) {
      if (title) return title.substring(0, 260)
      else return 'Undefined Transport'
    },
    gettitleProduction(title) {
      if (title) return title
      else return 'Undefined Transport'
    },
    removeEvent() {
      //close popup
    },
    openEditEvent(event) {
      const e = this.$store.getters['calendar/getEvent'](event.id)
      this.id = e.id
      this.product_name = e.product_name
      this.title = e.label + " #" + e.id
      this.startDate = e.startDate
      this.labelLocal = e.label
      this.category_name = e.category_name
      this.client = e.client
      this.client2 = e.client2
      this.volume = e.volume
      this.ref_quote = e.ref_quote
      this.client = e.client
      this.volume2 = e.volume2
      this.price2 = e.price2
      this.price = e.price
      this.activePromptEditEvent = true
    },
    clickViewEvent(type) {
      if (type.includes("purchase")) this.$router.push({ path: "/purchase/" + this.id });
      else this.$router.push({ path: "/" + type + "/" + this.id });
    },
    getColor(e) {
      return e.replace("event-", "")
    },
    eventsForDay(dayDate, type) {
      return this.$store.state.calendar.events.filter(event =>
        moment(event.startDate).format('YYYY-MM-DD') === dayDate
      ).filter(event => event.label === type);
    },
    generateWeekDays(currentMoment) {
      this.weekDays = Array.from({ length: 7 }).map((_, index) => {
        let weekDay = currentMoment.clone().startOf('isoWeek').add(index, 'days');
        return {
          name: weekDay.format('ddd'),
          date: weekDay.format('D'),
          fullDate: weekDay.format('YYYY-MM-DD'),
        };
      });
    },
    navigateWeek(direction) {
      this.currentDate.add(direction, 'weeks');
      this.generateWeekDays(this.currentDate);
    },
    isToday(date) {
      return moment().format('YYYY-MM-DD') === date;
    },
  },
  created() {
    if (localStorage.getItem("login-roles").toLowerCase().includes("admin")) {
      this.isadmin = true
    }
    this.$store.registerModule('calendar', moduleCalendar)
    this.$store.dispatch('calendar/fetchEventsV2')
    this.generateWeekDays(this.currentDate);
  },
  beforeDestroy() {
    this.$store.unregisterModule('calendar')
  },
}
</script>


<style scoped>
.elegant-hr {
  border: 0;
  height: 2px;
  /* Épaisseur légèrement augmentée pour une meilleure visibilité */
  background-image: linear-gradient(to right, rgba(149, 190, 166, 0), #95bea6, rgba(149, 190, 166, 0));
  margin-top: 20px;
  /* Espace au-dessus de la ligne */
  margin-bottom: 20px;
  /* Espace en dessous de la ligne */
}


.weekly-calendar {
  max-width: 100%;
  overflow-x: auto;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.calendar-header {
  display: flex;
  justify-content: space-between;
  background-color: #95bea6;
  color: white;
  padding: 20px;
  border-radius: 8px 8px 0 0;
}

.week-days {
  display: flex;
}

.day-container {
  flex: 1;
  border-right: 2px dashed #f0f0f0;
  text-align: center;
}

.no-border {
  border-right: none;
}

.day {
  padding: 16px 0;
  cursor: pointer;
}

.day:hover {
  background-color: #efefef;
}

.today {
  background-color: #cfe1df;
  color: white;
  font-weight: bold;
}

.categories {
  background-color: #fff;
}

.category {
  padding: 8px;
  font-size: 10px;
  font-weight: bold;
  text-align: left;
  
}

.category:first-child {
  border-top: none;
}

.category-content {
  height: auto; /* Permet à la div de s'adapter à la hauteur du contenu */
  overflow: visible; /* Assure que tout le contenu est visible, ajustez selon le besoin */
}

.troisd {
  transition: transform 0.3s ease; /* Assure une transition douce */
  display: inline-block; /* Nécessaire pour que la transformation s'applique correctement */

}

.troisd:hover {
  transform: scale(1.1); /* Agrandit l'élément de 50% */
  border-color: white; 
  border: 1px  white;
}



</style>
